import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usersAPI, channelsAPI, videosAPI } from '../../services/api';
import Loading from '../../components/common/Loading';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    users: 0,
    channels: 0,
    videos: 0,
    pendingVideos: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [usersRes, channelsRes, videosRes] = await Promise.all([
          usersAPI.getAll({ limit: 1 }),
          channelsAPI.getAll({ limit: 1 }),
          videosAPI.getAll({ limit: 1 }),
        ]);

        const pendingVideosRes = await videosAPI.getAll({ status: 'pending', limit: 1 });

        setStats({
          users: usersRes.data.total || 0,
          channels: channelsRes.data.total || 0,
          videos: videosRes.data.total || 0,
          pendingVideos: pendingVideosRes.data.total || 0,
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) return <Loading />;

  const statCards = [
    {
      title: 'Utilisateurs',
      value: stats.users,
      icon: '👥',
      color: '#6366f1',
      link: '/dashboard/users',
    },
    {
      title: 'Chaînes',
      value: stats.channels,
      icon: '📺',
      color: '#8b5cf6',
      link: '/dashboard/channels',
    },
    {
      title: 'Vidéos',
      value: stats.videos,
      icon: '🎬',
      color: '#ec4899',
      link: '/dashboard/videos',
    },
    {
      title: 'Vidéos en attente',
      value: stats.pendingVideos,
      icon: '⏳',
      color: '#f59e0b',
      link: '/dashboard/videos?status=pending',
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Dashboard Admin</h1>
        <p style={styles.subtitle}>Vue d'ensemble de votre application</p>
      </div>

      <div style={styles.statsGrid}>
        {statCards.map((card, index) => (
          <Link
            key={index}
            to={card.link}
            style={{
              ...styles.statCard,
              '--card-color': card.color,
            }}
          >
            <div style={styles.statIcon}>{card.icon}</div>
            <div style={styles.statContent}>
              <h3 style={styles.statTitle}>{card.title}</h3>
              <p style={styles.statValue}>{card.value}</p>
            </div>
          </Link>
        ))}
      </div>

      <div style={styles.quickActions}>
        <h2 style={styles.sectionTitle}>Actions rapides</h2>
        <div style={styles.actionsGrid}>
          <Link to="/dashboard/users" style={styles.actionCard}>
            <span style={styles.actionIcon}>➕</span>
            <span>Ajouter un utilisateur</span>
          </Link>
          <Link to="/dashboard/channels" style={styles.actionCard}>
            <span style={styles.actionIcon}>➕</span>
            <span>Ajouter une chaîne</span>
          </Link>
          <Link to="/dashboard/videos" style={styles.actionCard}>
            <span style={styles.actionIcon}>➕</span>
            <span>Créer une vidéo</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    marginBottom: '2rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: 'var(--text)',
    marginBottom: '0.5rem',
  },
  subtitle: {
    color: 'var(--text-light)',
    fontSize: '1rem',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1.5rem',
    marginBottom: '3rem',
  },
  statCard: {
    background: 'white',
    borderRadius: '1rem',
    padding: '1.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    textDecoration: 'none',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
    borderLeft: '4px solid var(--card-color)',
  },
  statIcon: {
    fontSize: '2.5rem',
  },
  statContent: {
    flex: 1,
  },
  statTitle: {
    fontSize: '0.875rem',
    color: 'var(--text-light)',
    marginBottom: '0.25rem',
  },
  statValue: {
    fontSize: '2rem',
    fontWeight: 700,
    color: 'var(--text)',
  },
  quickActions: {
    background: 'white',
    borderRadius: '1rem',
    padding: '2rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: 'var(--text)',
    marginBottom: '1.5rem',
  },
  actionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1rem',
  },
  actionCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '1rem',
    background: 'var(--light)',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
    border: '1px solid var(--border)',
  },
  actionIcon: {
    fontSize: '1.5rem',
  },
};

export default AdminDashboard;








